// extracted by mini-css-extract-plugin
export default {"form":"EssayBox_form__v-37y","textarea":"EssayBox_textarea__y9HoR","button":"EssayBox_button__ZIo8M"};